import { useState } from "react"
import {
    CheckboxAge,
    CheckboxPrivacy,
    ContainerAge,
    ContainerPravicy, TextAge,
    TextPravicy,
    TextPravicyLink
} from "./CheckboxsStyle.styled";
import { CheckIconCheckBox } from "./IconCheck";
import { FormErrorsSignUp } from "../../TypeErrors";
import { ErrorTextUser } from "../SignUpModelStyles.styled";

interface CheckboxsProps {
    submitForm: boolean;
    formErrorsSignUp: FormErrorsSignUp;
}

export const Checkboxs: React.FC<CheckboxsProps> = ({ submitForm, formErrorsSignUp }) => {
    const [checkboxAge, setCheckboxAge] = useState<boolean>(false);
    const [checkboxPravicy, setCheckboxPravicy] = useState<boolean>(false)
    
    const checkBoxAge = () => setCheckboxAge(prev => !prev);
    const checkBoxPravicy = () => setCheckboxPravicy(prev => !prev);

    return (
        <div>
            <ContainerAge>
                <CheckboxAge className={formErrorsSignUp.ageRating && submitForm ? "error-animation-input" : ""} checked={checkboxAge} onClick={checkBoxAge}>
                    <input type="checkbox" name="ageRating" checked={checkboxAge} readOnly hidden />
                    {checkboxAge && <CheckIconCheckBox />}
                </CheckboxAge>
                    <TextAge className={formErrorsSignUp.ageRating && submitForm ? "error-animation-input" : ""}>I am 13 years or older or have parental consent.</TextAge>
            </ContainerAge>
            <ErrorTextUser className={formErrorsSignUp.ageRating && submitForm ? "error-animation" : ""}>
                {formErrorsSignUp.ageRating}
            </ErrorTextUser>

            <ContainerPravicy>
                <CheckboxPrivacy className={formErrorsSignUp.policyPrivacy && submitForm ? "error-animation-input" : ""} checked={checkboxPravicy} onClick={checkBoxPravicy}>
                    <input type="checkbox" name="policyPrivacy" checked={checkboxPravicy} readOnly hidden />
                    {checkboxPravicy && <CheckIconCheckBox />}
                </CheckboxPrivacy>
                <TextPravicy className={formErrorsSignUp.policyPrivacy && submitForm ? "error-animation-input" : ""}>I confirm that I have read and agree to the <TextPravicyLink href="/policy-privacy" target="_blank">Privacy Policy</TextPravicyLink></TextPravicy>
            </ContainerPravicy>
            <ErrorTextUser className={formErrorsSignUp.policyPrivacy && submitForm ? "error-animation" : ""}>
                {formErrorsSignUp.policyPrivacy}
            </ErrorTextUser>
        </div>
    )
}